import reactStringReplace from 'react-string-replace';

// MARK: React Components

export function GridSection(props) {
    return (
    <div className='gridSection' style={{width: props.maxWidth}}>
        <Grid 
            size={props.squareSize} 
            letters={props.values.rows}
            handleGridSquareClick={props.handleGridSquareClick}
        />
    </div>
    )
}

export function GridNote(props) {
    return (
        <div className='gridNote'>{props.noteLetter}</div>
    )
}

export function GridNoteRow(props) {
    const notes = []
    for (var n=0; n < props.noteLetters.length; n++) {
        notes.push(<GridNote noteLetter={props.noteLetters[n]}/>)
    }
    return (
        <div className='gridNoteRow'>
            {notes}
        </div>
    )
}

export function GridNoteGrid(props) {
    const rows = [];
    let rowLetters = [];
    for (var l=0; l < props.noteLetters.length; l++) {
        rowLetters.push(props.noteLetters[l])
        if (rowLetters.length == 4 || l == props.noteLetters.length-1) {
            rows.push(<GridNoteRow noteLetters={rowLetters}/>)
            rowLetters = [];
        }
    }

    return (
        <div className="gridNotesGrid">
            {rows}
        </div>
    )
}

export function GridSquare(props) {
    const extraClass = props.extraClass + (props.letter.selected ? " selected" : "")

    if (props.letter.letter != "") {
        // Proper letter
        return (
        <div 
            className={"gridSquareBase "  + extraClass}
            onClick={() => {props.handleGridSquareClick(props.row, props.col)}}
            key={"square"+props.row+props.col}
            row={props.row}
            col={props.col}
            style={{
                width: props.size+"px",
                height: props.size+"px",
            }}>
                <span 
                    style={{
                        fontSize: props.size*0.75,
                    }}
                >
                    {props.letter.letter}
                </span>
        </div>
        )
    } else {
        // Note mode
        return (
        <div 
            className={"gridSquareBase "  + extraClass}
            onClick={() => {props.handleGridSquareClick(props.row, props.col)}}
            key={"square"+props.row+props.col}
            row={props.row}
            col={props.col}
            style={{
                width: props.size+"px",
                height: props.size+"px",
            }}>
                <GridNoteGrid noteLetters={props.letter.notes}/>
        </div>            
        )
    }
}

export function GridRow(props) {
    const letters = props.letters;
    let cells = [];
    for(var col = 0; col < props.letters.length; col++) {
        const extraClass = col % 2 == 0 && props.row % 2 == 0 ? " gridSquareLetterFixed" : ""
        cells.push(<GridSquare 
                    extraClass={extraClass} 
                    size={props.size}
                    row={props.row}
                    col={col}
                    letter={letters[col]}
                    handleGridSquareClick={props.handleGridSquareClick}
                />)
    }
    
    return (
    <div className="gridRow">
            {cells}
    </div>
    )
}

export function Grid(props) {
    let rows = [];
    for(var row=0; row < 5; row++) {
        rows.push(<GridRow 
                    row={row} 
                    size={props.size} 
                    letters={props.letters[row]}
                    handleGridSquareClick={props.handleGridSquareClick}
                />)
    }

    return (
    <div>
        {rows}
    </div>
    )
}
